"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoicePage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const invoice_1 = require("../../sections/invoice");
const smart_vending_logo_black_png_1 = __importDefault(require("../../assets/sidebar/smart-vending-logo-black.png"));
const react_i18next_1 = require("react-i18next");
const InvoicePage = () => {
    const { id } = (0, react_router_dom_1.useParams)();
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(invoice_1.InvoiceProvider, { children: [(0, jsx_runtime_1.jsx)("div", { role: "navigation", className: "flex fixed top-0 left-0 w-full min-h-14 z-50 justify-center items-center bg-blue-950 shadow-md transition-all duration-300 ", children: (0, jsx_runtime_1.jsx)("span", { className: 'text-xl text-white text-center', children: t('invoiceClient') }) }), (0, jsx_runtime_1.jsxs)("div", { className: "pt-10", children: [(0, jsx_runtime_1.jsx)(invoice_1.InvoiceComponent, { id: id ?? '' }), (0, jsx_runtime_1.jsx)("img", { src: smart_vending_logo_black_png_1.default, alt: "Company Logo", className: "invoice-logo" })] })] }));
};
exports.InvoicePage = InvoicePage;
